import React from "react";
import { FaEdit } from "react-icons/fa";
import styles from "./SubCategoryCard.module.css";

export default function SubCategoryCard({
  subCat,
  items,
  openModal
}) {
  const isArray = Array.isArray(items);

  return (
    <div className={styles.subcategoryCard}>
      {/* HEADER */}
      <div className={styles.subcategoryHeader}>
        <h3 className={styles.subcategoryTitle}>{subCat}</h3>

        <button
          className={styles.smallEditBtn}
          onClick={() => openModal(subCat)}
        >
          <FaEdit size={14} />
        </button>
      </div>

      {/* VIEW MODE */}
      {isArray ? (
        subCat === "trustedContacts" ? (
          // ⭐ SPECIAL CASE FOR TRUSTED CONTACTS
          items.length > 0 ? (
            items.map((c, i) => (
              <div key={i} className={styles.itemRow}>
                <div className={styles.itemView}>
                  <span>Contact {i + 1}</span>
                  <span>Email: {c.contactEmail || "Not set"}</span>
                  <span>Phone: {c.phoneNumber || "Not set"}</span>
                </div>
              </div>
            ))
          ) : (
            <p className={styles.emptyText}>No contacts added</p>
          )
        ) : (
          // ⭐ DEFAULT ARRAY‑BASED SUBCATEGORIES
          items.length > 0 ? (
            items.map((item, i) => (
              <div key={i} className={styles.itemRow}>
                <div className={`${styles.itemView} ${styles["bg" + (i % 6)]}`}>
                  <span>{item.name}</span>

                  {item.amount !== undefined && <span>{item.amount}</span>}

                  {item.note && <span className={styles.note}>{item.note}</span>}

                  {item.fileURL && (
                    <a
                      href={item.fileURL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.fileName}
                    </a>
                  )}
                </div>
              </div>
            ))
          ) : (
            <p className={styles.emptyText}>No items</p>
          )
        )
      ) : (
        // ⭐ OBJECT‑BASED SUBCATEGORIES (Inactivity Settings)
        (() => {
          const settings = items || {
            inactivityPeriodInMonths: 0,
            reminderCountBeforeSend: 0
          };

          return (
            <div className={styles.objectSummary}>
              <p>
                Inactivity period: {settings.inactivityPeriodInMonths} month(s)
              </p>
              <p>
                Reminders before send: {settings.reminderCountBeforeSend}
              </p>
            </div>
          );
        })()
      )}
    </div>
  );
}
